module.exports = __webpack_public_path__ + "img/background00.20d79157.jpg";